"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const respuestasMercado = [{
  titulo: "Contratar un equipo de tecnología interno.",
  descripcion: "Caro, lento de ensamblar, difícil de retener."
}, {
  titulo: "Contratar una agencia.",
  descripcion: "Entrega un proyecto, factura y se va. El conocimiento queda con ellos. Cuando algo se rompe seis meses después, se contrata otra agencia."
}, {
  titulo: "Contratar un freelancer.",
  descripcion: "Resuelve lo puntual. No hay metodología, no hay continuidad, no hay arquitectura de fondo."
}];
export default function PorQueExiste() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="sobre-por-que-existe" id="por-que-existe" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-10">
            El problema que resolvemos.
          </h2>

          <div className="space-y-6 font-sans text-lg md:text-xl text-foreground/90 leading-relaxed max-w-3xl mb-12">
            <p>
              La mayoría de las PyMEs llegan a un punto donde la operación creció más rápido que los procesos. El equipo de quince personas que cabía en un Excel compartido ya tiene cuarenta. Las herramientas que se compraron por separado no se hablan entre ellas. Los reportes ejecutivos viven en hojas de cálculo que dependen de que alguien los actualice.
            </p>

            <p>La respuesta del mercado a este problema suele ser una de tres:</p>
          </div>

          <div className="space-y-10 mb-12">
            {respuestasMercado.map((respuesta, i) => <RespuestaItem key={i} respuesta={respuesta} index={i} />)}
          </div>

          <p className="font-sans text-lg md:text-xl text-foreground/90 leading-relaxed max-w-3xl border-t border-border/30 pt-10">
            Fulcro existe para cubrir el espacio que ninguna de las tres llena: capacidad técnica continua, con criterio estratégico, sin costo de equipo full-time, y con documentación que queda con el cliente.
          </p>
        </div>
      </div>
    </section>;
}
function RespuestaItem({
  respuesta,
  index
}: {
  respuesta: {
    titulo: string;
    descripcion: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <h3 className="font-serif text-2xl md:text-3xl text-foreground font-normal leading-tight mb-3">
        {respuesta.titulo}
      </h3>
      <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed max-w-3xl">
        {respuesta.descripcion}
      </p>
    </div>;
}